<template>
  <div class="shareholder">
    <h3 style="margin-bottom:20px;">子公司账期</h3>
    <TableView :data="data" :columns="columns" :pagination="false">
      <template v-slot:action="{ tableRow }" v-if="this.typeOperate != 1">
        <div>
          <a-button type="link" size="small" @click="handleEdit(tableRow)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-popconfirm
            title="是否删除该数据账期?"
            @confirm="handleDeleteConfirm(tableRow)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">
              删除
            </a-button>
          </a-popconfirm>
        </div>
      </template>
    </TableView>

    <div v-if="this.typeOperate != 1">
      <a-button class="width-100" icon="plus" type="dashed" @click="add">
        新增账期
      </a-button>
    </div>
    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
      ref="companyTermEdit"
    >
      <a-form :form="modalForm">
        <a-form-item label="业务类型">
          <a-select
            v-decorator="['business']"
            @change="value => getName(value)"
          >
            <a-select-option
              v-for="item in bgList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Segment">
          <a-select
            v-decorator="['segmentId']"
            @change="value => getLevel(value)"
          >
            <a-select-option
              v-for="item in segmentList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.segmentLevel }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="账期(天)">
          <a-input
            v-decorator="['term']"
            type="text"
            :maxLength="3"
            oninput="value=value.replace(/[^\d]/g,'')"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import mixin from './mixinContact'
import { getSegmentList, getBgList, selectName, selectLevel, getPeriodist } from '../api'
const data = []

export default {
  mixins: [mixin],
  name: 'ContactInfo',
  props: ['customerDetail', 'groupCode', 'typeOperate'],
  data() {
    return {
      modalForm: this.$form.createForm(this),
      data,
      modalTitle: '新增',
      visible: false,
      disabled: false,
      nameValue: '',
      businessList: [],
      segmentList: [],
      businessName: '',
      segmentLevel: '',
      type11: '',
      bgList: [],
      Model_Name: '',
    }
  },
  components: {
    TableView,
  },
  mounted() {
    this._getbgList()
    this.query()
  },
  methods: {
    async query() {
      this.data = this.customerDetail
    },
    //获取业务类型下拉选
    async _getbgList() {
      getBgList().then(({ data }) => {
        this.bgList = data
      })
    },
    // 取消弹框
    handleAfterClose() {
      this.id = null
      this.modalTitle = '新增'
    },
    //获取business的name
    async getName(business) {
      this.modalForm.setFieldsValue({ segmentId: '' })

      selectName(business).then(({ data }) => {
        this.businessName = data
      })
      //根据BG查Segment
      getSegmentList(business).then(({ data }) => {
        this.segmentList = data
      })
    },
    //获取segment的level
    async getLevel(segment) {
      selectLevel(segment).then(({ data }) => {
        this.segmentLevel = data
      })
    },

    // 提交
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          this.type11 = '1'
          if (!this.id) {
            this.type11 = '0'
            this.id = new Date().getTime()
          }
          try {
            const submitData = {
              ...values,
              id: this.id,
              code: this.groupCode,
              name: this.businessName,
              segment: this.segmentLevel,
            }
            if (this.type11 == '0') {
              for (let i = 0; i < this.data.length; i++) {
                const business = this.data[i].business
                const segmentId = this.data[i].segmentId
                if (
                  business == submitData.business &&
                  segmentId == submitData.segmentId
                ) {
                  this.visible = false
                  return this.$message.error('BG+Segment账期已存在！')
                }
              }
              
              const periodData = {
                term: submitData.term,
              }
              const { data } = await getPeriodist(periodData)
              this.periodBo = data.aboolean
              if (this.periodBo == true) {
                this.data.push(submitData)
                this.visible = false
              } else if (this.periodBo == false) {
                this.$confirm({
                  title: '提示',
                  content: '该账期非标准账期，是否继续?',
                  okButtonProps: {
                    loading: this.loading,
                  },
                  cancelText: '否',
                  okText: '是',
                  onOk: () => {
                    this.loading = true
                    this.data.push(submitData)
                    this.visible = false
                  },
                  onCancel: () => {
                    this.loading = true
                    this.visible = false
                  }
                })
              }
            } else {
              for (let i = 0; i < this.data.length; i++) {
                const business = this.data[i].business
                const segmentId = this.data[i].segmentId
                const id = this.data[i].id
                if (
                  business == submitData.business &&
                  id != submitData.id &&
                  segmentId == submitData.segmentId
                ) {
                  this.visible = false
                  return this.$message.error('BG+Segment账期已存在！')
                }
              }

              const periodData = {
                term: submitData.term,
              }
              const { data } = await getPeriodist(periodData)
              this.periodBo = data.aboolean
              if (this.periodBo == true) {
                this.data.forEach(element => {
                  if (element.id == submitData.id) {
                    element.business = submitData.business
                    element.segmentId = submitData.segmentId
                    element.term = submitData.term
                    element.name = submitData.name
                    element.segment = submitData.segment
                  }
                })
                this.visible = false
              } else if (this.periodBo == false) {
                this.$confirm({
                  title: '提示',
                  content: '该账期非标准账期，是否继续?',
                  okButtonProps: {
                    loading: this.loading,
                  },
                  cancelText: '否',
                  okText: '是',
                  onOk: () => {
                    this.loading = true
                    this.data.forEach(element => {
                      if (element.id == submitData.id) {
                        element.business = submitData.business
                        element.segmentId = submitData.segmentId
                        element.term = submitData.term
                        element.name = submitData.name
                        element.segment = submitData.segment
                      }
                  })
                    this.visible = false
                  },
                  onCancel: () => {
                    this.loading = true
                    this.visible = false
                  }
                })
              }
              
            }
            //this.visible = false
            this.query()
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    //删除
    async handleDeleteConfirm({ id }) {
      try {
        this.data.forEach((element, index) => {
          if (element.id == id) {
            this.data.splice(index, 1)
          }
        })
        this.$notification.success({
          message: '提示',
        })
        this.query()
      } catch (error) {
        console.log(error)
      }
    },
    //修改
    async handleEdit({ business, segmentId, term, id, name, segment }) {
      this.visible = true
      this.modalTitle = '编辑'
      this.modalTitle === '编辑'
        ? (this.disabled = true)
        : (this.disabled = false)

      this.getName(business)
      setTimeout(() => {
        this.$nextTick(() => {
          this.modalForm.setFieldsValue({
            business,
            segmentId,
            term,
          })
        })
        this.id = id
        this.businessName = name
        this.segmentLevel = segment
      }, 20)
    },
    //新增
    add() {
      this.disabled = true
      this.visible = true
      this.modalForm.resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
